import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useAppState } from '@afosto/app-components-react/AppProvider';
import { useFormContext } from '@afosto/app-components-react/Form';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Autocomplete from '@afosto/app-components-react/Autocomplete';
import translations from './translations';

const LocationFormSection = ({ name, title, type, locations }) => {
  const intl = useIntl();
  const { settings } = useAppState();
  const formContext = useFormContext();
  const { watch } = formContext ?? {};
  const locationValue = watch(name);
  const { locations: locationIds = [] } = settings ?? {};
  const availableLocations = locations
    .map(location => ({
      ...location,
      label: location.name,
      value: location.id,
    }))
    .filter(location => {
      if (
        locationIds?.length > 0 &&
        (type !== 'transfer' || (type === 'transfer' && name === 'fromLocation'))
      ) {
        return locationIds.includes(location?.id);
      }

      return true;
    });
  const formRef = useRef(formContext);

  useEffect(() => {
    formRef.current = formContext;
  });

  useEffect(() => {
    if (availableLocations?.length === 1 && !locationValue) {
      const [firstLocation] = availableLocations ?? [];
      formRef.current.setValue(name, firstLocation);
    }
  }, [availableLocations, locationValue, name]);

  return (
    <Card style={{ marginBottom: 8 }}>
      <CardHeader title={title} titleTypographyProps={{ variant: 'h6' }} />
      <CardContent>
        <Autocomplete
          name={name}
          label={intl.formatMessage(translations.fields[name].label)}
          options={availableLocations}
        />
      </CardContent>
    </Card>
  );
};

LocationFormSection.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  locations: PropTypes.array,
};

LocationFormSection.defaultProps = {
  title: undefined,
  type: 'outbound',
  name: 'location',
  locations: [],
};

export default LocationFormSection;
